import { useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { isStandaloneFlightsEnabled } from 'selectors/flightsSelectors'
import {
  LUX_PLUS_SIA_MASTERCARD_CAMPAIGN_START_DATE,
  LUX_PLUS_SIA_MASTERCARD_CAMPAIGN_END_DATE,
} from '../constants/luxPlusSingaporeAirlinesMastercardTakeoverConstants'

/**
 * Hook to determine if the LuxPlus SIA Mastercard banner should be shown.
 * Checks campaign period, LuxPlus feature toggle, flights enabled status,
 * and only shows in AU region.
 */
export function useShowLuxPlusSiaMastercardBanner(): boolean {
  const isLuxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)
  const isFlightsEnabled = useAppSelector(isStandaloneFlightsEnabled)
  const currentRegionCode = useAppSelector((state) => state.geo.currentRegionCode)

  return useMemo(() => {
    const now = new Date()
    const isWithinCampaignPeriod =
      now >= LUX_PLUS_SIA_MASTERCARD_CAMPAIGN_START_DATE &&
      now <= LUX_PLUS_SIA_MASTERCARD_CAMPAIGN_END_DATE

    // Only show banner in AU region
    if (currentRegionCode !== 'AU') {
      return false
    }

    return isWithinCampaignPeriod && isLuxPlusEnabled && isFlightsEnabled
  }, [isLuxPlusEnabled, isFlightsEnabled, currentRegionCode])
}
